import styled from "styled-components";

interface SelectProps {
  fullWidth: boolean;
  shortWidth?: boolean;
  showOptions: boolean;
  indexLevel: number;
  fadeOut?: boolean;
}

export const SelectWrapper = styled.div<SelectProps>`
  text-align: left;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "47%")};
  opacity: 0;
  animation: inputFadeIn 0.5s ease-in forwards;
  position: relative; /* ensures dropdown is positioned relative to wrapper */
  z-index: ${({ indexLevel }) => 1000 + indexLevel};

  @media (max-width: 831px) {
    width: 100%;
  }

  .label-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .select-wrapper {
    width: 100%;
    position: relative;

    .select-input {
      width: 100%;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border: 1px solid ${({ theme }) => theme.border.input};
      border-radius: 0.3rem;
      background: white;
      cursor: pointer;
      position: relative;

      input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        padding: 0.75rem 1rem;
        font-size: 0.875rem;
        background: transparent;
      }

      h4 {
        color: #9ca3af;
        padding: 0.75rem 1rem;
      }

      .icon {
        position: absolute;
        right: 10px;
        transition: transform 0.3s ease-in-out;
        transform: ${({ showOptions }) =>
          showOptions ? "rotate(180deg)" : "rotate(0deg)"};
      }
    }

    .select-options {
      position: absolute;
      top: 110%;
      left: 0;
      width: 100%;
      z-index: 999999; /* keep this high, but meaningful */
      background: #fff;
      border: 1px solid ${({ theme }) => theme.border.light};
      border-radius: 0.25rem;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      max-height: 15rem;
      overflow-y: auto;
      animation: fadeIn 0.25s ease-in-out forwards;

      li {
        padding: 0.75rem 1rem;
        cursor: pointer;
      }

      li:hover {
        background: ${({ theme }) => theme.bg.prim_400};
      }
    }
  }

  @keyframes inputFadeIn {
    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
